import React from 'react';
import { Outlet } from 'react-router-dom';

const FindMeetingsLayout = () => <Outlet />;

export default FindMeetingsLayout;
